import { CustomLevel } from '@/common/types/customLevel';
import {
  DotsThreeVerticalIcon,
  PencilSimpleIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shadcn/components/dropdown-menu';
import { TableCell, TableRow } from '@shadcn/components/table';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface CustomLevelTableRowProps {
  customLevel: CustomLevel;
  onConfirmDelete: () => void;
}

export default function CustomLevelTableRow({
  customLevel,
  onConfirmDelete,
}: CustomLevelTableRowProps) {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  function handleNavigate() {
    navigate(`/dashboard/customlevels/${customLevel.id}`);
  }

  const displayName = customLevel.description || 'Untitled Level';

  return (
    <TableRow className="cursor-pointer" onClick={handleNavigate}>
      <TableCell>
        <div className="flex items-center gap-3 font-medium">{displayName}</div>
      </TableCell>
      <TableCell className="text-neutral-500">
        {dayjs(customLevel.updatedAt).fromNow()}
      </TableCell>
      <TableCell className="flex justify-end">
        <DropdownMenu open={isDropdownOpen} onOpenChange={setDropdownOpen}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="p-1/2"
              onClick={(e) => e.stopPropagation()}
            >
              <DotsThreeVerticalIcon size={24} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
            <DropdownMenuLabel>{displayName}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2"
              onClick={() => {
                setDropdownOpen(false);
                handleNavigate();
              }}
            >
              <PencilSimpleIcon weight="bold" size={16} /> Edit
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="flex gap-2 text-red-600"
              onClick={() => {
                setDropdownOpen(false);
                onConfirmDelete();
              }}
            >
              <TrashIcon weight="bold" size={16} /> Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
}
